// src/components/Layout.js
import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom"; // Importando Link para navegação
import {
  RiDashboardLine,
  RiMapPinLine,
  RiTeamLine,
  RiSettings3Line,
  RiLogoutBoxRLine,
  RiUser3Line,
  RiBuildingLine,
  RiOilLine,
  RiFileList2Line,
  RiSearchLine,
  RiNotificationLine,
  RiDropdownList,
  RiPriceTag3Line,
  RiUserVoiceLine
} from "react-icons/ri";

const Container = styled.div`
  display: flex;
  height: 100vh;
`;

const Menu = styled.nav`
  width: 158px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 18px;
`;

const MenuHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 24px;

  svg {
    margin-right: 8px;
  }
`;

const CompanyName = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 100; /* Use 300 para o peso light */
  font-family: 'Roboto', sans-serif;
  margin-bottom: 8px;
`;

const UserName = styled.div`
  font-size: 12px;
  color: #7d7d7d;
`;

const MenuItem = styled(Link)` // Usando Link para navegação
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-size: 13px;
  color: inherit;
  text-decoration: none; // Remover sublinhado

  &:hover {
    background-color: #cedce8;
  }

  svg {
    margin-right: 8px;
    margin-left: 12px;
  }
`;

const BottomMenu = styled.div`margin-top: auto;`;

const Content = styled.div`
  flex: 1;
  padding-left: 21px;
  padding-right: 21px;
  padding-top: 2px;
  overflow-y: auto;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
`;

const Title = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-size: 24px;
  font-weight: 300;
  margin-right: auto;
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-radius: 2px;
  padding: 4px 8px;
  margin-left: 16px;
  border: 1px solid #ddd;

  &:focus-within {
    border-color: #1565c0;
  }
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  padding: 4px 8px;
  flex: 1;
  font-size: 14px;
`;

const SearchButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;

const NotificationWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
  cursor: pointer;
`;

export const Layout = ({ children, pageTitle }) => {
  return (
    <Container>
      <Menu>
        <div>
          <MenuHeader>
            <CompanyName>
              <RiDropdownList />
              Unity elevadores
            </CompanyName>
            <UserName>Fabiano Santos</UserName>
          </MenuHeader>

          <MenuItem to="/customer-management">
            <RiBuildingLine /> Clientes
          </MenuItem>

          <MenuItem to="/customer-map">
            <RiBuildingLine /> Mapa de Clientes
          </MenuItem>

          <MenuItem to="/pendencias">
            <RiPriceTag3Line />Pendencias
          </MenuItem>
          <MenuItem to="/team-management">
            <RiTeamLine /> Equipe
          </MenuItem>
        </div>
        <BottomMenu>
          <MenuItem to="/logout">
            <RiLogoutBoxRLine /> Logout
          </MenuItem>
        </BottomMenu>
      </Menu>
      <Content>
        <Header>
          <Title>
            {pageTitle}
          </Title>
          <div style={{ display: "flex", alignItems: "center" }} />
        </Header>
        {children}
      </Content>
    </Container>
  );
};
